<template>
  <div>
    <v-card class="point" @click="dialog = true">
      <v-card-title
        class="text-h6 grey lighten-2"
        style="justify-content: center"
      >
        Manage Working Hours
      </v-card-title>
      <v-img
        :src="require(`@/assets/img/updateinfo/calendar-clock.webp`)"
        max-height="300"
        contain
        class="grey lighten-3 pa-5"
      ></v-img>
    </v-card>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="1240px"
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-icon left color="white">mdi-calendar-clock</v-icon>
          Working Hours & Availability Manager
        </v-toolbar>
        <v-card-text style="height: 70vh">
          <v-container>
            <WorkingHoursManagerComp :adi_id="adiinfo.adiid" />
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import WorkingHoursManagerComp from "@/components/Instructor/Availability/WorkingHoursManagerComp.vue";

export default {
  name: "WorkingHoursManager",
  components: { WorkingHoursManagerComp },
  props: ["adiinfo"],
  data() {
    return {
      dialog: false,
    };
  },
  validations: {
    form: {},
  },
  computed: {},
  created() {
    // this.assignData(this.adiinfo);
  },
};
</script>

<style></style>
